import { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "./leaveCalendar.css";
import api from "../../../services/api";
import { toast } from "react-toastify";
import strings from "../../../utils/property-file/scheduleLeave.json";
import moment from "moment";
import SpinnerButtonMedium from "../../button/SpinnerButtonMedium";
import appStyles from "../../../utils/appStyles";
import Select from "react-select";
import React from "react";
import PropTypes from "prop-types";

export default function LeaveCalendar(props) {
  const [currentDate, setCurrentDate] = useState([]);
  const [reason , setReason] = useState("");
  const selectedFormattedDate = currentDate.map((date) =>
    moment(date).format("YYYY-MM-DD")
  );
  const [selectedLeaveType , setSelectedLeaveType] = useState("");
  const handleCancel = () => {
    setCurrentDate([]);
    if(empLeaveReason.length>0){
      setEmpLeaveReason([])
    }
  };
  const [empLeaveReason ,setEmpLeaveReason] =useState([]);
  const [markedDates, setMarkedDates] = useState([]);
  const [formattedMonth, setFormattedMonth] = useState("");
  const [totalDays , setTotalDays] = useState("");
  const [applyingLeave , setApplyingLeave] = useState(false);
  useEffect(() => {
    const prevButton = document.querySelector(strings.prevBtnClass);
    const handlePrevButtonClick = () => {
      const monthString = document.getElementsByClassName(
        strings.getMonthNameClass
      )[0].innerText;
      const monthYearString = monthString;
      const date = new Date(monthYearString);
      date.setMonth(date.getMonth() - 1);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      setFormattedMonth(`${month}/${year}`);
    };
    prevButton.addEventListener("click", handlePrevButtonClick);
    return () => {
      prevButton.removeEventListener("click", handlePrevButtonClick);
    };
  }, []);

  useEffect(() => {
    const prevButton = document.querySelector(strings.nextBtnClass);
    const handlePrevButtonClick = () => {
      const monthString = document.getElementsByClassName(
        strings.getMonthNameClass
      )[0].innerText;
      const monthYearString = monthString;
      const date = new Date(monthYearString);
      date.setMonth(date.getMonth() + 1);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      setFormattedMonth(`${month}/${year}`);
    };

    prevButton.addEventListener(strings.clickLabel, handlePrevButtonClick);
    return () => {
      prevButton.removeEventListener(strings.clickLabel, handlePrevButtonClick);
    };
  }, []);

  const defaultDate = moment(new Date()).format("MM/YYYY");
  const getEmpLeave = async (props) => {
    try {
      const response = await api.getEmployeeLeave(
        props.selectedEmployeeName.value
          ? props.selectedEmployeeName.value
          : "",
        formattedMonth ? formattedMonth.toString() : defaultDate.toString(),
        props.type
      );
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setMarkedDates(data.body);
        } else {
          setMarkedDates(data.body === strings.noRecordLabel ? "" : data.body);
        }
      }
    } catch (error) {
      toast.error(strings.somethingWentWrongLabel, { toastId: "error6" });
    }
  };

  function calculateDurationInDays(startDateString, endDateString) {
    var startDate = new Date(startDateString);
    var endDate = new Date(endDateString);
    var timeDifference = endDate - startDate;
    var daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    setTotalDays(daysDifference || daysDifference ==0? daysDifference : null);
  }

  useEffect(()=>{
    calculateDurationInDays(selectedFormattedDate[0],selectedFormattedDate[1])
  },[selectedFormattedDate])


  useEffect(() => {
    getEmpLeave(props);
  }, [formattedMonth, props]);

  const tileClassName = ({ date }) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const dateString = `${year}-${month}-${day}T00:00:00.000Z`;
    const currentDate = new Date();
    const isPastDate = date < currentDate;
    if (markedDates.includes(dateString)) {
      return isPastDate ? strings.markedPastDate : strings.markedDate;
    } else if (isPastDate) {
      return strings.pastDate;
    } else {
      return "";
    }
  };

  const getLeaveReason = async (props, selectedFormattedDate) => {
    try {
      const body = {
        employeeId: props.selectedEmployeeName.value,
        duration: selectedFormattedDate,
        type: props.type,
      };
      const response = await api.getEmployeeLeaveReason(body);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setEmpLeaveReason(data.employeeReasonData ? data.employeeReasonData : []);
        } else {
          setEmpLeaveReason([]);
        }
      }
    } catch (error) {
      toast.error(strings.somethingWentWrongLabel, { toastId: "error6" });
      setEmpLeaveReason([]);
    }
  };

  const applyEmployeeLeave = async () =>{
    try {
      if(reason === "" || reason.length < 10) {
        if(reason === "" ) {
        toast.error(strings.reasonRequiredLabel , {toastId : "error7"})
        }
        else if(reason.length < 10) {
          toast.error(strings.reasonLengthLabel , {toastId : "error7"})
        }
        return;
      }
      if(selectedLeaveType==="" && props.type===strings.leaveLabel) { 
        toast.error(strings.leaveSelectionError , {toastId : "error7"})
        return;
      }
      setApplyingLeave(true);
      const body ={
        employeeId : props.selectedEmployeeName.value,
        reason : reason ,
        date : selectedFormattedDate,
        totalDays :  totalDays===null ? 0 : parseInt(totalDays) +1,
        leaveType : props.type===strings.leaveLabel ? selectedLeaveType : null,
        type : props.type
      }
      const response = await api.applyLeave(body);
      if(response && response.data) {
        const data = JSON.parse(response.data);
        if(response.success) {
          getLeaveReason(props, selectedFormattedDate);
          toast.success(data.body , {toastId : "error6"})
          getEmpLeave(props);
          setReason("");
        }
        else {
          toast.error(data.body , {toastId : "error7"})
        }
      }
      setApplyingLeave(false);
    }
    catch (error) {
      toast.error(strings.somethingWentWrongLabel , {toastId : "error7"})
      setApplyingLeave(false);
    }
  }

  useEffect(() => {
    if (selectedFormattedDate.length > 0) {
      getLeaveReason(props, selectedFormattedDate);
    }
  }, [currentDate]);

  useEffect(()=>{
    handleCancel();
  },[props])

  return (
    <div className="schedule-leave-main-container">
    {props.type===strings.leaveLabel?  <div className="reason-leave-container mt-3">
     <label htmlFor="" className="reason-leave-label">
          {strings.leaveTypeLabel}
        </label>
     <Select
            className="emp-name-select-leave"
            isDisabled={empLeaveReason.length>0}
            options={strings.leaveTypes}
            styles={appStyles.companyProfileDropdown}
            onChange={(selectedLeave) => {
              setSelectedLeaveType(selectedLeave.value);
            }
            }
          />
     </div> : null}
      <div className="reason-leave-container mt-3">
        <label htmlFor="" className="reason-leave-label">
          {strings.reasonLabel}
        </label>
        {empLeaveReason.length > 0 ? (
          <div className="reason-reflect">
            {empLeaveReason.map((reason, index) => (
              <p key={index}>
                {index + 1} :
                <span className="reason-date me-1">
                  {moment(reason.date).format("DD-MM-YYYY")}
                </span>
                <span className="me-1"> ({reason.status})</span>
                {reason.reason[0]}
              </p>
            ))}
          </div>
        ) : (
          <textarea
            type="text"
            className="d-block reason-leave"
            placeholder={strings.enterReason}
            onChange={((reason)=>{setReason((reason.target.value).trim())})}
          ></textarea>
        )}
      </div>
      <div className="note-for-calendar">{strings.noteForCalendar}</div>
      <Calendar
        className={props.type===strings.leaveLabel ? "leave-calendar-main-container" : "wfh-calendar-main-container"}
        tileClassName={tileClassName}
        value={currentDate}
        selectRange={true}
        onChange={(date) => setCurrentDate(date)}
      />
      <div className="apply-leave-section">
        <div className="apply-leave-section-selected-days">
          {strings.totalDaysLabel} : { totalDays===null ? 0 : parseInt(totalDays) +1}
        </div>
        <div className="apply-leave-button-schedule-leave">
        <button className="cancel-button-schedule-leave" disabled={currentDate.length===0 || applyingLeave} onClick={(()=>{handleCancel()})}>{strings.cancelButtonLabel}</button>
        <button className="submit-button-schedule-leave" disabled={empLeaveReason.length>0 || currentDate.length===0 || applyingLeave}  onClick={(()=>{applyEmployeeLeave()})}>{applyingLeave ? <SpinnerButtonMedium /> :strings.submitButtonLabel}</button>
      </div>
      </div>
    </div>
  );
}

LeaveCalendar.propTypes = {
  selectedEmployeeName : PropTypes.any.isRequired,
  type : PropTypes.any.isRequired
}